import JobApplicationForm from './Form.vue';
import ManagementPanel from './ManagementPanel.vue';

export const recruitmentRoutes = [
  {
    path: '/public/forms/:account_id/jobs',
    name: 'public_job_application_form',
    meta: { public: true, permissions: [] },
    component: JobApplicationForm,
  },
  {
    path: '/public/recruitment/:token',
    name: 'public_recruitment_management',
    meta: { public: true, permissions: [] },
    component: ManagementPanel,
  },
];
